import { hexToRgba } from "utils/styles/hex-to-rgba";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type CircleComponentState = {
  color: string;
};

export class CircleComponent extends Webgl2Component<undefined, CircleComponentState> {
  private _measurementHeight = 3;

  constructor(color: string) {
    super({ color });
    this._calcTransform();
  }

  public setHeightSize(height: number) {
    this._measurementHeight = Math.max(height, 1);
    this._calcTransform();
  }

  private _calcTransform() {
    const radius = this._measurementHeight * 2.5;
    const d = radius * 2;
    this.transform.setSize(d, d);
  }

  public getRenderData() {
    const material = Webgl2.materials.circle;
    // @ts-ignore
    material.setUniform("u_color", hexToRgba(this.state.color, true));
    return { material };
  }
}

export default CircleComponent;
